module.exports = __webpack_public_path__ + "img/badge-silver-reward.3c0f0b4.png";